// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"451":"65eb2c9d","453":"9f1d6a0c"}[chunkId] + ".chunk.js";
};